module.exports = __webpack_public_path__ + "img/close.a827a852.png";